import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import {
    ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend,
} from 'recharts';
import strings from '../../utils/strings';

export default function PieGraph({ data }) {
    const [chartData, setChartData] = useState(data)
    const colors = ['#3A9EFD', '#51DBC8', '#FF4DFF', '#FFBEBE', '#B30000'
        , '#F0F285', '#0000FF', '#272643', '#FF9999', '#B36BA1', '#9C2BF2', '#FFFF00', '#C6FDFF'
    ];
    useEffect(() => {
        setChartData(data)

    }, [data])

    if (!data) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }



    return (
        <div style={{ width: '100%', height: 400 }}>
            <ResponsiveContainer>
                <PieChart>
                    <Pie
                      direction="ltr"
                        data={chartData}
                        dataKey="SaleCount"
                        nameKey="InsuranceTypeName" fill="#82ca9d" width={800} height={800}>
                        {chartData.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)}
                    </Pie>
                    <Tooltip
                        contentStyle={{
                            color: '#fff',
                            backgroundColor: '#000',
                            minWidth: '100px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                        itemStyle={{
                            color: '#fff',
                            direction: 'ltr',
                        }}
                        formatter={(value, name) => [strings.getFarsiNum(value)]}
                    />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};
